
import React from 'react'

export const ConfirmPurchase = ({}) => {


  
    return (
        <div className='container'>
            <div className='row w-100 flex-column justify-content-center text-center'>
                <h2>Resumen de la compra.</h2>
                <i> Recibo y confirmación de la compra </i>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div>
                        <h3>Detalle</h3>
                        <ul>
                            <li>Total por productos</li>
                            <li>Costo de envio</li>
                            <li>Total (IVA incluido en caso de ser aplicable)</li>
                        </ul>
                    </div>
                    <div>
                        <h3>Dirección de envio</h3>
                        <p>
                            <span>

                            </span>
                        </p>
                    </div>
                    <div>
                        <h3>Información del pago</h3>
                        <p>
                            <span>

                            </span>
                        </p>
                    </div>
                </div>
                <div className=''>
                    <div className='d-flex '>
                        <button> Realizar pedido</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
